import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'top_match_face_info';
export const useTopMatchFaceInfoTranslation = (): UseTranslationResponse<string, string> => (
  useTranslation('entities', { keyPrefix })
);

export const ruRu = ({
  [keyPrefix]: {
    similarity: 'Лицо',
    user_data: 'Информация',
    external_id: 'Внешний ID',
    lists: 'Списки',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    similarity: 'Face',
    user_data: 'Information',
    external_id: 'External ID',
    lists: 'Lists',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    similarity: 'Face',
    user_data: 'Informação',
    external_id: 'ID externo',
    lists: 'Listas',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    similarity: 'Rostro',
    user_data: 'Información',
    external_id: 'ID externo',
    lists: 'Listas',
  },
}) as Record<string, unknown>;
